import { render } from "./ItemIcon.vue?vue&type=template&id=8e44a09a&scoped=true"
import script from "./ItemIcon.vue?vue&type=script&lang=js"
export * from "./ItemIcon.vue?vue&type=script&lang=js"

import "./ItemIcon.vue?vue&type=style&index=0&id=8e44a09a&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e44a09a"]])

export default __exports__